<template>
    <div class="h-100">
        <b-modal
            id="api-err-modal"
            v-model="apiErrModalShow"
            centered
            scrollable
            hide-footer
            hide-header-close
            no-close-on-backdrop
            no-close-on-esc
            title="Error"
            :header-bg-variant="'warning'"
            :header-text-variant="'light'">
            No collection codes found for given household and/or collection date.
            <b-button class="mt-3" block @click="hideModal">OK</b-button>
        </b-modal>
        <b-container fluid>
            <h2 class="tw-mb-0 text-aegis-dk">
                Collection Code Lookup
            </h2>
            <p class="tw-italic tw-text-gray-700">
                Enter a household ID and collection date.
            </p>
        </b-container>

        <b-container fluid>
            <b-row>
                <b-col>
                    <b-form-input
                        label="Household ID"
                        placeholder="Household ID"
                        v-model="compound"
                        size="lg"
                        @keypress.enter="search()"
                        @click:append="search()"
                    ></b-form-input>
                </b-col>
                <b-col cols="auto">
                    <b-form-datepicker
                        id="start_date"
                        v-model="collectionDate"
                        placeholder="Collection Date"
                        class="mb-2"
                        size="lg"
                    >
                    </b-form-datepicker>
                </b-col>
                <b-col cols="auto">
                    <b-button @click="search()" block size="lg" variant="success">
                       Search
                    </b-button>
                </b-col>
                <b-col cols="auto">
                    <b-button @click="clear()" block size="lg" variant="danger">
                       Clear
                    </b-button>
                </b-col>
            </b-row>
        </b-container>

        <hr />

        <b-container fluid>
            <b-row>
                <b-col v-if="collectionCodes.length">
                    <b-table
                        striped
                        hover
                        :fields="fields"
                        :items="collectionCodes"
                        :tbody-tr-class="'clickable'"
                        @row-clicked="rowClicked"
                    >
                   </b-table>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import { mapActions } from "vuex";
import * as _ from "lodash";

export default {
    components: {},
    mixins: [DashboardBaseTemplate],
    data: function () {
        return {
            collectionCodes: [],
            collectionDate: '',
            compound: '',
            fields: [
              { key: 'collection_code', sortable: true},
              { key: 'compound', sortable: true},
              { key: 'collection_date', sortable: true},
            ],
            apiErrModalShow: false,
        };
    },
    mounted() {
        const that = this;

        if(that.$route.query.tabIndex) {
            that.tabIndex = parseInt(that.$route.query.tabIndex);
        }
    },
    methods: {
        ...mapActions("websheet", ["getEntoCollectionCodes", "getEntoData"]),
        search: async function () {
            const that = this;
            that.collectionCodes = [];
            const response = await HTTP.get('/srilanka/search-codes-codes-by-structure/', {
                params: {
                    compound: that.compound,  // '1501-01-0270101'
                    collection_date: that.collectionDate  // '2021-12-05'
                }
            });
            if(response.data.length) {
                that.collectionCodes = response.data;
            } else {
                this.apiErrModalShow = true;
            }
        },
        clear () {
            const that = this;
            that.collectionCodes = [];
            that.collectionDate = null;
            that.compound = ''
        },
        rowClicked (record) {
            const that = this;
            console.log(record)
            // that.$router.push({
            //     name: "mosquito-data-entry",
            //     params: {templateId: "ento_its2",},
            //     query: {collectionCode: record["collection_code"]},
            // });
            that.$router.push({
                name: "new-collection",
                query: {collectionCode: record["collection_code"]},
            });
        },
        hideModal() {
            this.apiErrModalShow = false;
        },
    },
};
</script>

<style>
@import "~handsontable/dist/handsontable.full.css";

.ht {
    width: 100%;
}
.nav-tabs .nav-link {
    font-weight: 500;
    color: #999;
}
</style>
